import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RadioOption} from './radio-option';

@Component({
    selector: 'pf-radio-enhanced',
    imports: [CommonModule],
    templateUrl: './radio-enhanced.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioEnhancedComponent {
    @Input() legend?: string;
    @Input() name: string = 'name';
    @Input() options: RadioOption[] = [];
    @Input() value: any = null;
    @Input() required: boolean = true;
    @Output() valueChange = new EventEmitter<any>();

    onSelectionChange(newValue: any): void {
        this.value = newValue;
        this.valueChange.emit(newValue);
    }
}